import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ZfFormField, ZfFilesUpload } from '@zafire/react';
import contactNoteFromEmailService from 'services/contactNoteFromEmailService';
import { setIsDrawerOpen } from 'reducers/drawerReducer';
import { openModal } from 'reducers/modalReducer';
import { useHost } from 'contexts/Host';

const MAX_FILE_SIZE = 12 * 1024 * 1024; // 12MB
export const EmailDragAndDrop = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isWena } = useHost();
  const handleOnDropEmail = async (event: CustomEvent) => {
    try {
      if (event.detail.size > MAX_FILE_SIZE) {
        throw new Error(t('drawer.section.contactNoteUpload.fileLimitExceed'));
      }
      const response = await contactNoteFromEmailService.getContactNoteFromEmail(event.detail, isWena);
      dispatch(setIsDrawerOpen(false));
      dispatch(
        openModal({
          modalType: 'ContactNoteFromEmailModal',
          modalProps: { contactNoteEmailData: response },
        }),
      );
    } catch (error) {
      const isExceedingFileSizeLimit =
        error instanceof Error && error.message === t('drawer.section.contactNoteUpload.fileLimitExceed');
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            technicalInfo: {
              details: isExceedingFileSizeLimit
                ? error.message
                : 'Error getting the contact note from the email from pcc-contact-note-mgmt',
              title: isExceedingFileSizeLimit ? error.message : 'Error getting the contact note from the email',
              userErrorMessage: 'An error occurred while Error getting the contact note from the email',
            },
            httpError: error,
          },
        }),
      );
    }
  };
  return (
    <div>
      <ZfFormField label="">
        <ZfFilesUpload
          text="Drag e-mail file here or click to upload"
          hasDropzone
          onFileUpload={handleOnDropEmail}
          accept=".msg"
          data-testid="email-file-uploader"
        />
      </ZfFormField>
    </div>
  );
};
